module.exports = __webpack_public_path__ + "img/b2.9b508619.png";